var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18.1452 16.4997",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M7.41195 0.268485C7.76993 -0.0894952 8.35019 -0.089495 8.70817 0.268485C9.06593 0.626484 9.06608 1.2068 8.70817 1.56471L2.93962 7.33326H17.2285C17.7348 7.33326 18.1452 7.74367 18.1452 8.24993C18.145 8.75601 17.7346 9.1666 17.2285 9.1666H2.93962L8.70817 14.9352C9.06593 15.2932 9.06608 15.8735 8.70817 16.2314C8.35027 16.5892 7.76994 16.5891 7.41195 16.2314L0.402674 9.2221C-0.134238 8.68515 -0.134212 7.81473 0.402674 7.27776L7.41195 0.268485Z",
    fill: "var(--fill-0, #131C20)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.0cbf9e837933b3749169c09a90cfd2b1.svg";
export { ForwardRef as ReactComponent };